// import React from 'react';
// import { 
//   ShieldCheck, ShieldAlert, Award, Scale, 
//   ChevronLeft, Building2, Eye, FileText, 
//   Briefcase, CheckCircle2 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function ComplianceAndGovernance() {
  
//   // Core compliance and governance modules
//   const governanceServices = [
//     {
//       title: "صياغة لوائح وأنظمة الحوكمة",
//       desc: "إعداد وتطوير أدلة حوكمة الشركات، وسياسات تنظيم علاقات مجلس الإدارة والمساهمين، وتشكيل اللجان المنبثقة (المراجعة، الترشيحات والمكافآت) وفقاً لأنظمة هيئة السوق المالية ووزارة التجارة.",
//       icon: <Building2 className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "التدقيق وتقييم الامتثال التنظيمي",
//       desc: "إجراء فحص دوري شامل لمدى التزام المنشأة بالأنظمة واللوائح والقرارات الوزارية السارية بمختلف القطاعات، وإعداد تقارير الفجوات (Gap Analysis) لتفادي الغرامات.",
//       icon: <Eye className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "حوكمة ومواثيق الشركات العائلية",
//       desc: "صياغة وتطوير الدساتير والمواثيق العائلية (Family Constitutions) التي تنظم انتقال الملكية والإدارة بين الأجيال، وحل النزاعات الداخلية لضمان استدامة الكيان التجاري.",
//       icon: <FileText className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "برامج مكافحة الفساد وغسل الأموال",
//       desc: "تصميم وتطبيق سياسات الامتثال الداخلي لمكافحة غسل الأموال (AML) ومكافحة التستر التجاري، وتقديم التدريب اللازم للموظفين والمسؤولين التنفيذيين لضمان التوافق التام مع المعايير الوطنية.",
//       icon: <ShieldCheck className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-white text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات الحوكمة والامتثال القانوني"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">حماية الكيانات المؤسسية وتعزيز الموثوقية الاستثمارية</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات الحوكمة والامتثال القانوني</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نحن نساعد منشأتك على بناء بيئة تشغيلية آمنة وشفافة من خلال مواءمة كافة أنشطتها وعقودها مع البيئة التشريعية المتسارعة في المملكة العربية السعودية، مما يرفع تصنيفك الائتماني ويجذب الاستثمارات.
//           </p>
//         </div>
//       </section>

//       {/* Analytical & Preventive Value Focus */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
//               الامتثال ليس مجرد التزام بالنظام، بل هو استراتيجية نمو
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               مع تشديد الرقابة وتفعيل أنظمة الربط الإلكتروني بين الجهات الحكومية المختلفة، أصبحت تكلفة عدم الامتثال باهظة للغاية وقد تؤدي إلى شلل فوري في العمليات التجارية للشركات.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               يعمل فريقنا الاستشاري على مراجعة دقيقة ومستمرة لكافة مستويات الإدارة والتشغيل والتوظيف داخل منشأتك، لتحديد المخاطر القانونية الكامنة والعمل على علاجها فوراً. نحن نصمم لك نظام حوكمة مرن يحقق التوازن الفعلي بين تسيير الأعمال اليومية وصلاحيات الرقابة الإدارية والمالية.
//             </p>
//           </div>
          
//           {/* Why Implement Governance Framework Box */}
//           <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 space-y-6">
//             <h3 className="text-xl font-bold text-slate-800 mb-2 flex items-center gap-2">
//               <Award className="w-5 h-5 text-amber-600" /> فوائد تبني أطر الحوكمة والامتثال:
//             </h3>
            
//             <div className="flex gap-3 items-start">
//               <CheckCircle2 className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**تحصين القيادة:** حماية أعضاء مجالس الإدارة من المسؤولية القانونية والشخصية والتعويضات.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle2 className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**تعزيز الجاذبية الاستثمارية:** تأهيل الشركات لجذب صناديق الاستثمار الكبرى ورؤوس الأموال الأجنبية.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle2 className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**الاستدامة التشغيلية:** تقليل احتمالية نشوء النزاعات الداخلية والخارجية وضمان انسيابية القرار.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Grid Capability Matrix Breakdown */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">نطاق عمل الحوكمة ومواءمة الأنظمة</h2>
//             <p className="text-slate-400 max-w-xl mx-auto">حلول وهياكل تنظيمية مصممة خصيصاً لتتناسب مع حجم شركتك وتطلعاتها التوسعية</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {governanceServices.map((service, index) => (
//               <div key={index} className="bg-slate-800/60 p-8 rounded-xl border border-slate-700 hover:border-amber-500 transition-all duration-300">
//                 <div className="bg-slate-700/50 p-3 rounded-lg w-fit mb-5">
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-100 mb-2">{service.title}</h3>
//                 <p className="text-slate-400 text-sm leading-relaxed">{service.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Regulatory/Offensive Warning Banner */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <ShieldAlert className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">إشعار نظامي بشأن مسؤولية المديرين:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               وفقاً لمقتضيات نظام الشركات الجديد في المملكة العربية السعودية، تم تفعيل معايير صارمة بخصوص واجب الرعاية والولاء الملقى على عاتق أعضاء مجالس الإدارة والمسؤولين التنفيذيين. إن أي تقصير أو إهمال في تطبيق لوائح الامتثال الداخلي قد يؤدي إلى مساءلتهم شخصياً ومطالبتهم بالتعويض عن الخسائر التي تلحق بالشركة أو الشركاء.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Active Lead Gen Conversion Block */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <Briefcase className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل ترغب في رفع مستوى الامتثال والحوكمة بشركتك؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           تواصل معنا اليوم لتقييم الوضع القانوني والتنظيمي الحالي لمنشأتك، ودع مستشارينا يصيغون لك الإطار الحمائي الأنسب لأعمالك.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب تقييم شامل للامتثال والحوكمة
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }

import React from 'react';
import { 
  ShieldCheck, ShieldAlert, Award, Scale, 
  ChevronLeft, Building2, Eye, FileText, 
  Briefcase, CheckCircle2 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';

export default function ComplianceAndGovernance() {
  
  // Core compliance and governance modules - Refactored to Navy Light
  const governanceServices = [
    {
      title: "صياغة لوائح وأنظمة الحوكمة",
      desc: "إعداد وتطوير أدلة حوكمة الشركات، وسياسات تنظيم علاقات مجلس الإدارة والمساهمين، وتشكيل اللجان المنبثقة (المراجعة، الترشيحات والمكافآت) وفقاً لأنظمة هيئة السوق المالية ووزارة التجارة.",
      icon: <Building2 className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "التدقيق وتقييم الامتثال التنظيمي",
      desc: "إجراء فحص دوري شامل لمدى التزام المنشأة بالأنظمة واللوائح والقرارات الوزارية السارية بمختلف القطاعات، وإعداد تقارير الفجوات (Gap Analysis) لتفادي الغرامات.",
      icon: <Eye className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "حوكمة ومواثيق الشركات العائلية",
      desc: "صياغة وتطوير الدساتير والمواثيق العائلية (Family Constitutions) التي تنظم انتقال الملكية والإدارة بين الأجيال، وحل النزاعات الداخلية لضمان استدامة الكيان التجاري.",
      icon: <FileText className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "برامج مكافحة الفساد وغسل الأموال",
      desc: "تصميم وتطبيق سياسات الامتثال الداخلي لمكافحة غسل الأموال (AML) ومكافحة التستر التجاري، وتقديم التدريب اللازم للموظفين والمسؤولين التنفيذيين لضمان التوافق التام مع المعايير الوطنية.",
      icon: <ShieldCheck className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات الحوكمة والامتثال القانوني"
        description="نصمم أطر الامتثال والحوكمة المؤسسية لحماية منشأتكم وتعزيز موثوقيتها الاستثمارية"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">حماية الكيانات المؤسسية وتعزيز الموثوقية الاستثمارية</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات الحوكمة والامتثال القانوني</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نحن نساعد منشأتك على بناء بيئة تشغيلية آمنة وشفافة من خلال مواءمة كافة أنشطتها وعقودها مع البيئة التشريعية المتسارعة في المملكة العربية السعودية، مما يرفع تصنيفك الائتماني ويجذب الاستثمارات.
          </p>
        </div>
      </section>

      {/* Analytical & Preventive Value Focus */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              الامتثال ليس مجرد التزام بالنظام، بل هو استراتيجية نمو
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              مع تشديد الرقابة وتفعيل أنظمة الربط الإلكتروني بين الجهات الحكومية المختلفة، أصبحت تكلفة عدم الامتثال باهظة للغاية وقد تؤدي إلى شلل فوري في العمليات التجارية للشركات.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              يعمل فريقنا الاستشاري على مراجعة دقيقة ومستمرة لكافة مستويات الإدارة والتشغيل والتوظيف داخل منشأتك، لتحديد المخاطر القانونية الكامنة والعمل على علاجها فوراً. نحن نصمم لك نظام حوكمة مرن يحقق التوازن الفعلي بين تسيير الأعمال اليومية وصلاحيات الرقابة الإدارية والمالية.
            </p>
          </div>
          
          {/* Why Implement Governance Framework Box - Refactored to Executive Light Mode */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200/60 space-y-6 shadow-sm">
            <h3 className="text-xl font-bold text-indigo-950 mb-2 flex items-center gap-2">
              <Award className="w-5 h-5 text-blue-700" /> فوائد تبني أطر الحوكمة والامتثال:
            </h3>
            
            <div className="flex gap-3 items-start">
              <CheckCircle2 className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">تحصين القيادة:</strong> حماية أعضاء مجالس الإدارة من المسؤولية القانونية والشخصية والتعويضات.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle2 className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">تعزيز الجاذبية الاستثمارية:</strong> تأهيل الشركات لجذب صناديق الاستثمار الكبرى ورؤوس الأموال الأجنبية.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle2 className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">الاستدامة التشغيلية:</strong> تقليل احتمالية نشوء النزاعات الداخلية والخارجية وضمان انسيابية القرار.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Grid Capability Matrix Breakdown - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">نطاق عمل الحوكمة ومواءمة الأنظمة</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">حلول وهياكل تنظيمية مصممة خصيصاً لتتناسب مع حجم شركتك وتطلعاتها التوسعية</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {governanceServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Regulatory/Offensive Warning Banner - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <ShieldAlert className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">إشعار نظامي بشأن مسؤولية المديرين:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              وفقاً لمقتضيات نظام الشركات الجديد في المملكة العربية السعودية، تم تفعيل معايير صارمة بخصوص واجب الرعاية والولاء الملقى على عاتق أعضاء مجالس الإدارة والمسؤولين التنفيذيين. إن أي تقصير أو إهمال في تطبيق لوائح الامتثال الداخلي قد يؤدي إلى مساءلتهم شخصياً ومطالبتهم بالتعويض عن الخسائر التي تلحق بالشركة أو الشركاء.
            </p>
          </div>
        </div>
      </section>

      {/* Active Lead Gen Conversion Block - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <Briefcase className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2" >هل ترغب في رفع مستوى الامتثال والحوكمة بشركتك     </h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          تواصل معنا اليوم لتقييم الوضع القانوني والتنظيمي الحالي لمنشأتك، ودع مستشارينا يصيغون لك الإطار الحمائي الأنسب لأعمالك.
        </p>
        <button 
        
                          onClick={() => openWhatsApp( "   طلب تقييم شامل للامتثال والحوكمة    ")}

        className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200  inline-flex items-center gap-2">
          طلب تقييم شامل للامتثال والحوكمة
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}